




















import Vue from "vue";
import { IKeyword, IState } from "../store/state";

import KeywordItem from "./KeywordItem.vue";

interface KeywordListData {}

interface KeywordListProps {}

interface KeywordListComputed {
  keywords: IKeyword[];
}

export default Vue.extend<
  KeywordListData,
  {},
  KeywordListComputed,
  KeywordListProps
>({
  name: "KeywordList",
  inheritAttrs: false,
  model: {
    prop: "checked",
    event: "change"
  },
  computed: {
    keywords() {
      return (this.$store.state as IState).keywords;
    }
  },
  components: {
    KeywordItem
  }
});
